import { useState } from 'react'
import { Image } from 'antd'
import { PictureOutlined } from '@ant-design/icons'
import { resolveAttachmentUrl } from './utils'
import styles from './Chat.module.css'

interface Props {
  urls: string[]
}

function ChatAttachThumb({ url }: { url: string }) {
  const src = resolveAttachmentUrl(url)
  const [failed, setFailed] = useState(false)

  if (!src || failed) {
    return (
      <div className={styles.attachFallback} title="Не удалось загрузить">
        <PictureOutlined />
        <span>Фото недоступно</span>
      </div>
    )
  }

  return (
    <Image
      src={src}
      width={168}
      className={styles.attachImg}
      style={{ objectFit: 'cover', borderRadius: 10, maxHeight: 220 }}
      alt=""
      onError={() => setFailed(true)}
    />
  )
}

export function ChatAttachments({ urls }: Props) {
  if (!urls?.length) return null
  const resolved = urls.map(resolveAttachmentUrl).filter(Boolean)
  return (
    <div className={styles.attachments}>
      <Image.PreviewGroup items={resolved}>
        {urls.map((url) => (
          <ChatAttachThumb key={url} url={url} />
        ))}
      </Image.PreviewGroup>
    </div>
  )
}
